// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"307":"f6621cb8","813":"dd90a63f"}[chunkId] + ".chunk.css";
};